import root from 'window-or-global';

// Adapted from https://github.com/videojs/video.js/blob/master/src/js/fullscreen-api.js
export const apiMap = {
    DEFAULT: {
        request: 'requestFullscreen',
        exit: 'exitFullscreen',
        element: 'fullscreenElement',
        change: 'fullscreenchange'
    },
    WEBKIT: {
        request: 'webkitRequestFullscreen',
        exit: 'webkitExitFullscreen',
        element: 'webkitFullscreenElement',
        change: 'webkitfullscreenchange'
    },
    MOZILLA: {
        request: 'mozRequestFullScreen',
        exit: 'mozCancelFullScreen',
        element: 'mozFullScreenElement',
        change: 'mozfullscreenchange'
    },
    MICROSOFT: {
        request: 'msRequestFullscreen',
        exit: 'msExitFullscreen',
        element: 'msFullscreenElement',
        change: 'MSFullscreenChange'
    }
};

// Singleton utility to:
// - determine the browser's fullscreen API
// - publish updates as fullscreen state changes
// - expose API-compatible exitFullScreen and requestFullScreen functions
class FullScreenManager {
    subscribers = {};
    didInit = false;
    currentKey = 0;
    isFullScreen = false;

    _init() {
        this.didInit = true;
        this._updateFullScreen();
        root.document.addEventListener(this.api.change, this._updateFullScreen);
    }

    _updateFullScreen = () => {
        this.api = this.api || this._getApi();
        this.isFullScreen = !!root.document[this.api.element];
        this._publish();
    };

    _getApi = () => {
        let out;

        Object.keys(apiMap).some(apiType => {
            const api = apiMap[apiType];

            if (root.document[api.exit]) {
                out = api;
                return true;
            }

            return false;
        });

        return out || apiMap.DEFAULT;
    };

    _publish = () => {
        Object.keys(this.subscribers).forEach(key => {
            const callback = this.subscribers[key];
            callback(this.isFullScreen);
        });
    };

    exitFullScreen = () => {
        root.document[this.api.exit]();
    };

    requestFullScreen = element => {
        element[this.api.request]();
    };

    getIsFullScreen = () => this.isFullScreen;

    subscribe = fn => {
        if (!this.didInit) this._init();

        fn(this.isFullScreen);

        this.currentKey += 1;
        this.subscribers[this.currentKey] = fn;

        return this.currentKey;
    };

    unsubscribe = key => {
        delete this.subscribers[key];
    };
}

export default new FullScreenManager();
